import { render, staticRenderFns } from "./bookingResultsPage.vue?vue&type=template&id=97eb0cf8&scoped=true"
import script from "./bookingResultsPage.vue?vue&type=script&lang=ts"
export * from "./bookingResultsPage.vue?vue&type=script&lang=ts"
import style0 from "./bookingResultsPage.vue?vue&type=style&index=0&id=97eb0cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eb0cf8",
  null
  
)

export default component.exports